import Container from '@/components/global/Container';
import { VideoElement } from '@/components/shared/VideoElement/VideoElement';
import { IComponentBlocksVideo } from '@/graphql/__generated__/global/types';

const VideoBlock = ({ mux_video_uploader_mux_asset }: IComponentBlocksVideo) => {
    if (!mux_video_uploader_mux_asset) {
        return;
    }

    return (
        <Container className="flex flex-row align-center justify-center">
            <VideoElement mux_asset={mux_video_uploader_mux_asset} />
        </Container>
    );
};

export default VideoBlock;
